export const ANALYTICS_BEHAVIORAL_HUB_EVENT = 'itau-trader:analytics:event';

export interface BehavioralHubAnalyticsEvent {
  analytics: {
    event_name: string;
    parameters: {
      custom_path: string;
      implementation_team?: string;
      detail: string;
    };
  };
}
